import { ClassFlag } from "../../../../../library-js/dom-tools/ClassFlag";
import { ElementType } from "../../../../../library-js/dom-tools/ElementType";
import { OnTouchCancel, OnTouchEnd, OnTouchStart } from "../../../../../library-js/dom-tools/EventListeners";
import { DomElement } from "../../../../../library/ts/html/dom/DomElement";

export class ReminderButton extends DomElement<HTMLElement>
{
  static type = new ElementType( "reminder-button" );
  
  static mail = new ClassFlag( "mail" );
  static clock = new ClassFlag( "clock" );
  static calender = new ClassFlag( "calender" );

  static delete = new ClassFlag( "delete" );
  static back = new ClassFlag( "back" );
  static save = new ClassFlag( "save" );

  constructor( e:HTMLElement )
  {
    super( e );   

    OnTouchStart.add( this.element,
      ( )=>
      {
        ClassFlag.touched.setAs( this.element, true );
      }
    );
 
    OnTouchCancel.add( this.element,
      ( )=>
      {
        ClassFlag.touched.setAs( this.element, false );
      }
    );

    OnTouchEnd.add( this.element,
      ( )=>
      {
        ClassFlag.touched.setAs( this.element, false );
      }
    );
  }
}